module.exports = __webpack_public_path__ + "static/media/civic-logo-c-invert.562ec4a2.svg";